import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import DrawerModal from '../../shared/DrawerModal';
import styles from './BookingCancelModal.styles';
import {
  closeModal,
  getIsVisibleModal,
} from '../../../redux/store/ui/common/index';
import {
  cancelBooking,
  selectSelectedBooking,
} from '../../../redux/store/userData/trips';
import {
  fetchCarActiveBookings,
  getActiveBooking,
  selectTimeTableCars,
} from '../../../redux/store/userData/cars';
import { useIntl } from 'react-intl';

const BookingCancelModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const displayCars = useSelector(selectTimeTableCars);
  const selectedBookig = useSelector(selectSelectedBooking);
  const visibleModal = useSelector(getIsVisibleModal('BookingCancelModal'));

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(
      cancelBooking(selectedBookig?.id, () => {
        if (selectedBookig?.confirmedCarId) {
          dispatch(fetchCarActiveBookings(selectedBookig.confirmedCarId));
        }
        // Refresh the timetable's active bookings so a cancelled status-change
        // booking's background band disappears on success (selectActiveBookings →
        // statusChangeBookings → status period bands in VehicleTimeline).
        if (displayCars?.length) {
          dispatch(getActiveBooking(displayCars.map((car) => car.id)));
        }
      })
    );
    dispatch(closeModal('BookingCancelModal'));
  };
  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('BookingCancelModal'));
  };

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('BookingCancelModal'));
        }}
      >
        <div className="booking-cancel-modal">
          <div className="booking-cancel-wrapper">
            <div className="booking-cancel-modal-inputs">
              <p data-testid="BookingCancelModal-modalLabel" className="label">
                {intl.formatMessage({
                  id: `fleetadmin.booking.cancel.title`,
                })}
              </p>
            </div>
          </div>
          <Button
            data-testid="BookingCancelModal-cancelBtn"
            className="submit-button"
            onClick={handleOnSubmit}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default BookingCancelModal;
